import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';

import { TipoServicoModel } from '../models';

@Injectable({
  providedIn: 'root'
})
export class TipoServicoService extends BaseCrudService<TipoServicoModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'TipoServico';
  }

  getAll(): Observable<TipoServicoModel[]> {
    return this
      .httpClient
      .get<TipoServicoModel>(`${this.getApiUrl()}${this.getController()}`, this.getHeaderJson())
      .pipe(
        map(this.extractData)
      );
  }

  updateOrdens(tipoServicoIds) {
    return this
      .httpClient
      .post(`${this.getApiUrl()}${this.getController()}/UpdateOrdens`, tipoServicoIds, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
